import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { ValidarUsuarioRequestDto } from '../../../dto/auth/validar-usuario.request.dto';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { timer } from 'rxjs';
import { UsuarioService } from '../../../services/usuario.service';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-validar-usuario',
  templateUrl: './validar-usuario.component.html',
  styleUrl: './validar-usuario.component.scss',
})
export class ValidarUsuarioComponent implements OnInit {
  validarUsuarioForm: FormField[] = [];
  token?: string;

  // Multilenguaje
  validarUsuarioText: any = {};
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly usuarioService: UsuarioService,
    private readonly alertaModalService: AlertaModalService,
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {
    this.translate.stream('form_validar_usuario').forEach(text => {
      for (const key of Object.keys(text)) {
        this.validarUsuarioText[key] = text[key];
      }
      this.ngOnInit();
    });
  }

  ngOnInit(): void { 
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.token = params['token'];
    });
    this.cargarFormulario();
  }

  cargarFormulario() {
    this.validarUsuarioForm = [
      {
        name: 'email',
        label: this.validarUsuarioText['email'],
        type: 'text',
        placeholder: this.validarUsuarioText['email_placeholder'],
        required: true,
        width: '12',
        visible: true,
        validation: [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        ],
        errorMessages: {
          required: this.validarUsuarioText['email_required'],
          pattern: this.validarUsuarioText['email_pattern']
        },
      },
    ];
  }

  onSubmitValidarUsuario(form: FormGroup) {
    const request: ValidarUsuarioRequestDto = {
      email: form.get('email')?.value,
      token: form.get('token')?.value,
    };
    if (this.token == undefined) {
      this.alertaModalService.error(
        this.validarUsuarioText['error_token']
      );
    } else {
      this.usuarioService.validarUsuario(request.email, this.token).subscribe({
        next: () => {
          this.alertaModalService.exito(this.validarUsuarioText['exito']);
          timer(3000).subscribe(() => {
            this.redirect();
          });
        },
        error: () => {
          this.alertaModalService.error(
            this.validarUsuarioText['error_usuario'],
            this.validarUsuarioText['error_intente']
          );
        },
      });
    }
  }

  redirect() {
    this.router.navigate(['/login']);
  }
}
